import i18n from "i18n"
export const DATE_FORMAT = "MM/DD/YYYY"

export const SEASON_TYPES = {
  ALL_YEAR: "all-year",
  SEASONAL: "seasonal"
}

export const DATE_PICKER_PROPS = {
  autoComplete: "new-password",
  autoFill: "off",
  "data-form-type": "date"
}

export const DAYS = [
  { value: "sunday", label: i18n.t("experiences.days.sun") },
  { value: "monday", label: i18n.t("experiences.days.mon") },
  { value: "tuesday", label: i18n.t("experiences.days.tue") },
  { value: "wednesday", label: i18n.t("experiences.days.wed") },
  { value: "thursday", label: i18n.t("experiences.days.thu") },
  { value: "friday", label: i18n.t("experiences.days.fri") },
  { value: "saturday", label: i18n.t("experiences.days.sat") }
]

export const PRICING_TYPES = {
  PER_PERSON: "charge_per_person",
  FLAT_RATE: "charge_flat_rate"
}

export const TRIP_PRICE = {
  DURATION: "trip_duration",
  BUFFER_TIME: "trip_buffer_time",
  PRICE_ADULT: "price_per_person",
  PRICE_CHILD: "price_per_child",
  PRICE_INFANT: "price_per_infant",
  PRICE_PASSENGER: "price_per_passenger",
  FLAT_RATE: "flat_rate",
  CHILDREN_ALLOWED: "children_allowed",
  INFANTS_ALLOWED: "infants_allowed",
  PASSENGERS_ALLOWED: "passengers_allowed",
  EXTRA_GUESTS_ALLOWED: "extra_guests_allowed",
  MAX_EXTRA_GUESTS: "max_extra_guests"
}
